__turbopack_context__.v({
  "modal": "styles-module__CGtFMa__modal",
  "open": "styles-module__CGtFMa__open",
  "overlay": "styles-module__CGtFMa__overlay",
});
